import MoreVertIcon from "@mui/icons-material/MoreVert";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./Featured.scss";
import { colors } from "@mui/material";

const Featured = ({ title, value }) => {
    return (
        <div className="featured" style={{ background: 'white', margin: 10,borderRadius:8 }}>
            <div className="top">
                <h3 className="title" style={{fontSize:14}}>{title}</h3>
            </div>
            <div className="bottom">
                <div className="featuredChart">
                    <CircularProgressbar styles={{
                        text: {
                            // Text color
                            fill: '#025481',
                            // Text size
                            fontSize: '20px',
                            
                        },
                        path:{
                            stroke: ' #025481'
                        }
                        ,
                    }} value={value} text={`${value}%`} strokeWidth={5} />
                </div>
            </div>
        </div>
    )
}

export default Featured;